import React from 'react';

import Header from './Header';

import Topbar from './TopBar';

import Footer from './Footer';

import Contactpage from './Contactpage';

const Contact = () => {  
    
    return(
        <div>
            <Header/>
            <Topbar/>
            <Contactpage/>
            <Footer/>           
        </div>
        
    );
};

export default Contact;